export default [
  {
    path: "/instrument/library",
    name: "InstrumentLibrary",
    component: () => import("@/pages/instrument/library/index.vue"),
    meta: {
      title: "助学工具",
      requireAuth: true,
      authority: "instrument:library"
    },
    redirect: "/instrument/library/topic",
    children: [
      {
        path: "topic",
        name: "InstrumentLibraryTopic",
        component: () => import("@/pages/instrument/library/topic/index.vue"),
        meta: {
          title: "题库",
          requireAuth: true,
          authority: "instrument:library"
        }
      },
      {
        path: "papers",
        name: "InstrumentLibraryPapers",
        component: () => import("@/pages/instrument/library/papers/index.vue"),
        meta: {
          title: "试卷库",
          requireAuth: true,
          authority: "instrument:library"
        }
      },
    ]
  },
  {
    path: "/instrument/library/topic/add",
    name: "InstrumentLibraryTopicAddOrUpdate",
    component: () =>
      import("@/pages/instrument/library/topic/addOrUpdate/index.vue"),
    meta: {
      title: "添加题目",
      requireAuth: true,
      authority: "instrument:library"
    }
  },
  {
    path: "/instrument/library/topic/edit",
    name: "InstrumentLibraryTopicAddOrUpdate",
    component: () =>
      import("@/pages/instrument/library/topic/addOrUpdate/index.vue"),
    meta: {
      title: "编辑题目",
      requireAuth: true,
      authority: "instrument:library"
    }
  },
  {
    path: "/instrument/library/papers/add",
    name: "InstrumentLibraryPapersAddOrUpdate",
    component: () =>
      import("@/pages/instrument/library/papers/addOrUpdate/index.vue"),
    meta: {
      title: "新建试卷",
      requireAuth: true,
      authority: "instrument:library"
    }
  },
  {
    path: "/instrument/library/papers/edit",
    name: "InstrumentLibraryPapersAddOrUpdate",
    component: () =>
      import("@/pages/instrument/library/papers/addOrUpdate/index.vue"),
    meta: {
      title: "编辑试卷",
      requireAuth: true,
      authority: "instrument:library"
    }
  },
  {
    path: "/instrument/exercise",
    name: "InstrumentExercise",
    component: () => import("@/pages/instrument/exercise/index.vue"),
    meta: {
      title: "练习",
      requireAuth: true,
      authority: "instrument:exercise"
    }
  },
  {
    path: "/instrument/exercise/add",
    name: "InstrumentExerciseAddOrUpdate",
    component: () =>
      import("@/pages/instrument/exercise/addOrUpdate/index.vue"),
    meta: {
      title: "新建练习",
      requireAuth: true,
      authority: "instrument:exercise"
    }
  },
  {
    path: "/instrument/exercise/edit",
    name: "InstrumentExerciseAddOrUpdate",
    component: () =>
      import("@/pages/instrument/exercise/addOrUpdate/index.vue"),
    meta: {
      title: "编辑练习",
      requireAuth: true,
      authority: "instrument:exercise"
    }
  },
  {
    path: "/instrument/examination",
    name: "InstrumentExamination",
    component: () => import("@/pages/instrument/examination/index.vue"),
    meta: {
      title: "考试",
      requireAuth: true,
      authority: "instrument:examination"
    }
  },
  {
    path: "/instrument/examination/add",
    name: "InstrumentExaminationAddOrUpdate",
    component: () =>
      import("@/pages/instrument/examination/addOrUpdate/index.vue"),
    meta: {
      title: "添加考试",
      requireAuth: true,
      authority: "instrument:examination"
    }
  },
  {
    path: "/instrument/examination/edit",
    name: "InstrumentExaminationAddOrUpdate",
    component: () =>
      import("@/pages/instrument/examination/addOrUpdate/index.vue"),
    meta: {
      title: "编辑考试",
      requireAuth: true,
      authority: "instrument:examination"
    }
  },
  {
    path: "/instrument/examination/review",
    name: "InstrumentExaminationReview",
    component: () => import("@/pages/instrument/examination/review/index.vue"),
    meta: {
      title: "批阅列表",
      requireAuth: true,
      authority: "instrument:examination"
    }
  },
  {
    path: "/instrument/examination/details",
    name: "InstrumentExaminationDetails",
    component: () => import("@/pages/instrument/examination/details/index.vue"),
    meta: {
      title: "批阅详情",
      requireAuth: true,
      authority: "instrument:examination"
    }
  },
  {
    path: "/instrument/examination/analysis",
    name: "InstrumentExaminationAnalysis",
    component: () =>
      import("@/pages/instrument/examination/analysis/index.vue"),
    meta: {
      title: "统计分析",
      requireAuth: true,
      authority: "instrument:examination"
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/module/library.js